import { render } from "./SolutoButton.vue?vue&type=template&id=39e2e73c&scoped=true&ts=true"
import script from "./SolutoButton.vue?vue&type=script&lang=ts"
export * from "./SolutoButton.vue?vue&type=script&lang=ts"

import "./SolutoButton.vue?vue&type=style&index=0&id=39e2e73c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e2e73c"]])

export default __exports__